import logo from 'url:../images/logo.png';

const OKTA_CLIENT_ID = window.env.OKTA_CLIENT_ID || '0oawt4qsxfwCwohjC0h7';
const OKTA_ISSUER = window.env.OKTA_ISSUER || 'https://kagr.oktapreview.com/oauth2/default';
const OKTA_REQUEST_CONTEXT =
  window.env.OKTA_REQUEST_CONTEXT || '/home/oidc_client/0oawt4qsxfwCwohjC0h7/aln5z7uhkbM6y7bMy0g7';
const REDIRECT_URI = `${window.location.origin}/login/callback`;
const POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/login`;

const scopes = ['openid', 'profile', 'email'];

const oktaAuthConfig = {
  // Note: If your app is configured to use the Implicit flow
  // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
  // you will need to add `pkce: false`
  issuer: OKTA_ISSUER,
  clientId: OKTA_CLIENT_ID,
  redirectUri: REDIRECT_URI,
  postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI
};

const oktaSignInConfig = {
  baseUrl: OKTA_ISSUER.split('/oauth2')[0],
  clientId: OKTA_CLIENT_ID,
  logo: logo,
  redirectUri: REDIRECT_URI,
  // In version 7 of @okta/okta-signin-widget it defaults to using their Identity Engine
  // KAGR is still using the classic so this flag needs to be turned on until they switch to Identity Engine 
  // When moved to the Identity engine, remove this flag
  useClassicEngine: true,
  authParams: {
    // If your app is configured to use the Implicit flow
    // instead of the Authorization Code with Proof of Code Key Exchange (PKCE)
    // you will need to uncomment the below line
    pkce: true,
    OKTA_ISSUER,
    scopes
  },
  // Remove the features object when updating to use Identity engine
  features: {
    registration: false,
    multiOptionalFactorEnroll: true,
    idpDiscovery: true
  },
  i18n: {
    en: {
      'primaryauth.title': 'Sign in to KAGR'
    }
  },
  idpDiscovery: {
    requestContext: OKTA_REQUEST_CONTEXT
  }
};

export { oktaAuthConfig, oktaSignInConfig, scopes };
